<div class="header">
  <div class="orderToolbar">
    <h2 class="title">Заказы <span *ngIf="isClientContext" class="clientOrderCount">{{ resultsLength }}</span></h2>
    <div class="headerActions">
      <button *ngIf="!isClientContext" type="button" mat-stroked-button class="keyboardHelpButton"
        #keyboardHelpTooltip="matTooltip" [matTooltip]="keyboardHelpText"
        matTooltipClass="orderKeyboardTooltip" matTooltipPosition="below"
        aria-label="Горячие клавиши заказов" aria-keyshortcuts="Alt+0" (click)="keyboardHelpTooltip.toggle()">
        <mat-icon>keyboard</mat-icon><span>Клавиши</span>
      </button>
      <button type="button" mat-flat-button color="primary" (click)="toggleFab()" [disabled]="isClientContext && !clientId"
        [attr.aria-keyshortcuts]="isClientContext ? null : 'Alt+4'" [matTooltip]="isClientContext ? '' : 'Новый заказ · Alt+4'">
        <mat-icon>add</mat-icon> Новый заказ
      </button>
      <button *ngIf="!isClientContext" type="button" mat-stroked-button (click)="drawer.toggle()" [attr.aria-expanded]="drawer.opened"
        aria-keyshortcuts="Alt+3" matTooltip="Перейти к фильтрам · Alt+3">
        <mat-icon>filter_list</mat-icon> Фильтры
        <span *ngIf="managerFilterCount && !activeLookupQuery" class="filterCount">{{ managerFilterCount }}</span>
      </button>
    </div>
  </div>
  <div class="orderSearchForms">
    <form *ngIf="!isClientContext" class="searchPanel cashierSearch drop-padding" [class.searchPanelActive]="activeLookupQuery"
      (ngSubmit)="lookupOrders()" aria-label="Поиск для кассы"
      title="Введите номер заказа или телефон. Точный номер заказа будет первым, ниже — совпадения по телефону. Поиск по всем менеджерам и складам.">
      <div class="searchPanelHeading">
        <span class="searchPanelTitle">Касса</span><kbd class="searchShortcut" aria-hidden="true">F2</kbd>
      </div>
      <div class="searchPanelControls">
        <mat-form-field appearance="outline" floatLabel="never">
          <input #cashierSearchInput [formControl]="lookupControl" matInput type="text" placeholder="Телефон / ID" aria-keyshortcuts="F2"
            aria-label="Телефон клиента или ID заказа" />
          <button *ngIf="lookupControl.value || activeLookupQuery" type="button" mat-icon-button matSuffix
            aria-label="Очистить поиск по телефону или ID" (click)="clearLookup()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <button [disabled]="loading" type="submit" mat-flat-button class="searchSubmit"
          aria-label="Найти заказ по телефону или ID">
          <mat-icon *ngIf="!loading || !activeLookupQuery">search</mat-icon>
          <mat-spinner *ngIf="loading && activeLookupQuery" [diameter]="18"></mat-spinner>
        </button>
      </div>
    </form>
    <form class="searchPanel managerSearch drop-padding" [class.searchPanelActive]="!activeLookupQuery && activeManagerQuery"
      (ngSubmit)="searchManagerOrders()" aria-label="Поиск для менеджера"
      [title]="isClientContext ? 'По авто, VIN, артикулу или названию товара · только заказы этого клиента' : 'По имени или телефону клиента, авто, VIN, артикулу или названию товара · с учётом фильтров'">
      <div class="searchPanelHeading">
        <span class="searchPanelTitle">Менеджер</span><kbd *ngIf="!isClientContext" class="searchShortcut" aria-hidden="true">F3</kbd>
      </div>
      <div class="searchPanelControls">
        <mat-form-field appearance="outline" floatLabel="never">
          <input #managerSearchInput [formControl]="searchControl" matInput type="text" [attr.aria-keyshortcuts]="isClientContext ? null : 'F3'" [placeholder]="isClientContext ? 'Авто, VIN, артикул, товар' : 'Клиент, телефон, авто, VIN, товар'"
            aria-label="Имя или телефон клиента, авто, VIN, артикул или название товара" />
          <button *ngIf="searchControl.value || activeManagerQuery" type="button" mat-icon-button matSuffix
            aria-label="Очистить поиск для менеджера" (click)="clearManagerSearch()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <button [disabled]="loading" type="submit" mat-flat-button class="searchSubmit"
          aria-label="Найти заказ по клиенту, авто или товару">
          <mat-icon *ngIf="!loading || activeLookupQuery">search</mat-icon>
          <mat-spinner *ngIf="loading && !activeLookupQuery" [diameter]="18"></mat-spinner>
        </button>
      </div>
    </form>
  </div>
</div>

<div
  class="thermalMenuAnchor"
  [style.left]="thermalMenuPosition.x"
  [style.top]="thermalMenuPosition.y"
  [matMenuTriggerFor]="orderThermalMenu"
  #thermalMenuTrigger="matMenuTrigger"
></div>

<mat-menu #orderThermalMenu="matMenu" (closed)="closeOrderThermalMenu()">
  <button mat-menu-item (click)="handleOrderThermalMenuAction('local', false, $event)">
    <mat-icon>receipt</mat-icon>
    <span>Печать локально с ID</span>
  </button>
  <button mat-menu-item (click)="handleOrderThermalMenuAction('local', true, $event)">
    <mat-icon>receipt_long</mat-icon>
    <span>Печать локально с артикулом</span>
  </button>
  <button mat-menu-item (click)="handleOrderThermalMenuAction('agent', false, $event)">
    <mat-icon>alt_route</mat-icon>
    <span>Печать в другой агент с ID</span>
  </button>
  <button mat-menu-item (click)="handleOrderThermalMenuAction('agent', true, $event)">
    <mat-icon>alt_route</mat-icon>
    <span>Печать в другой агент с артикулом</span>
  </button>
</mat-menu>

<div
  class="thermalMenuAnchor"
  [style.left]="assemblyMenuPosition.x"
  [style.top]="assemblyMenuPosition.y"
  [matMenuTriggerFor]="assemblySheetMenu"
  #assemblyMenuTrigger="matMenuTrigger"
></div>

<mat-menu #assemblySheetMenu="matMenu" (closed)="closeAssemblySheetMenu()">
  <button mat-menu-item (click)="handleAssemblySheetMenuAction('local', $event)">
    <mat-icon>fact_check</mat-icon>
    <span>Сборочный лист локально</span>
  </button>
  <button mat-menu-item (click)="handleAssemblySheetMenuAction('agent', $event)">
    <mat-icon>alt_route</mat-icon>
    <span>Сборочный лист в другой агент</span>
  </button>
</mat-menu>

<details *ngIf="!isClientContext" class="quickFiltersDisclosure" [open]="!mobileLayout">
  <summary><mat-icon aria-hidden="true">tune</mat-icon> Быстрые фильтры<mat-icon class="disclosureChevron" aria-hidden="true">expand_more</mat-icon></summary>
<form class="quickFilters" [formGroup]="searchForm" (ngSubmit)="applyQuickFilters()" aria-label="Основные фильтры заказов">
  <mat-slide-toggle class="onlyMineFilter" [checked]="!activeLookupQuery && userControl.value?.id === user?.id"
    (toggleChange)="handleOnlyMeToggle()">Только мои</mat-slide-toggle>
  <div class="quickWarehouse">
    <app-warehouse-selector [control]="warehouseControl" (SelectWarehouse)="applyQuickFilters()"></app-warehouse-selector>
    <button *ngIf="warehouseControl.value" type="button" mat-icon-button class="clearQuickField"
      aria-label="Все склады" title="Все склады" (click)="clearQuickWarehouse()"><mat-icon>close</mat-icon></button>
  </div>
  <mat-form-field appearance="outline" class="quickFulfillment">
    <mat-label>Выполнение</mat-label>
    <mat-select formControlName="fulfillment_status" multiple (selectionChange)="applyQuickFilters()">
      <mat-option *ngFor="let option of fulfillmentStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="quickPeriod">
    <mat-label>Период создания</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate formControlName="date_from" placeholder="С" (dateChange)="!picker.opened && applyQuickFilters()" />
      <input matEndDate formControlName="date_to" placeholder="По" (dateChange)="!picker.opened && applyQuickFilters()" />
    </mat-date-range-input>
    <button *ngIf="date_from || date_to" type="button" mat-icon-button matSuffix
      aria-label="Очистить период" (click)="clearQuickPeriod()"><mat-icon>close</mat-icon></button>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker (closed)="applyQuickFilters()"></mat-date-range-picker>
  </mat-form-field>
  <span *ngIf="activeLookupQuery" class="quickFilterNotice"><mat-icon>info_outline</mat-icon> Поиск кассы — по всем заказам</span>
  <button type="button" mat-stroked-button class="defaultsButton" [class.hasDefaults]="user?.orderListDefaults"
    [disabled]="!user || defaultsDialogOpened" (click)="openDefaultFilters()"
    matTooltip="Фильтры при открытии заказов · для вашего аккаунта">
    <mat-icon>{{ user?.orderListDefaults ? 'bookmark' : 'bookmark_border' }}</mat-icon> По умолчанию
  </button>
</form>
</details>

<mat-drawer-container class="wrapper">
  <mat-drawer #drawer class="example-sidenav" [mode]="filtersOverlay ? 'over' : 'side'" [opened]="!isClientContext && !filtersOverlay" position="end">
    <form *ngIf="!isClientContext" class="searchForm" [formGroup]="searchForm" (ngSubmit)="applyFilters(); mobileLayout && searchForm.valid && drawer.close()">
      <div class="filterPanelHeader">
        <span class="filterHeading"><mat-icon>tune</mat-icon> Фильтры менеджера</span>
        <button type="button" mat-icon-button class="closeFilters" (click)="drawer.close()" aria-label="Скрыть фильтры"><mat-icon>close</mat-icon></button>
      </div>
      <div class="filterPanelBody">
        <div *ngIf="activeLookupQuery" class="lookupFilterNotice">
          «Применить» переключит на поиск для менеджера.
        </div>
        <section class="filterSection financeFilters">
          <h3><mat-icon>receipt_long</mat-icon> Заказ, оплата и выдача</h3>
          <div class="filterGrid">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>Отказы</mat-label>
              <mat-select formControlName="is_canceled" placeholder="Все заказы">
                <mat-option [value]="null">Все заказы</mat-option>
                <mat-option [value]="false">Без отказов</mat-option>
                <mat-option [value]="true">Только отказанные</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Оплата</mat-label>
              <mat-select #paymentFilter formControlName="payment_status" multiple>
                <mat-option *ngFor="let option of paymentStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Отгрузка</mat-label>
              <mat-select formControlName="shipment_status" multiple>
                <mat-option *ngFor="let option of shipmentStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>
        <section class="filterSection supplyFilters">
          <h3><mat-icon>inventory_2</mat-icon> Товар и закупка</h3>
          <div class="filterGrid">
            <mat-form-field appearance="outline">
              <mat-label>Готовность</mat-label>
              <mat-select formControlName="supply_status" multiple>
                <mat-option *ngFor="let option of supplyStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Закупка</mat-label>
              <mat-select formControlName="procurement_status" multiple>
                <mat-option *ngFor="let option of procurementStatusOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </section>
        <section class="filterSection extraFilters">
          <button type="button" class="extraFiltersToggle" mat-button (click)="extraFiltersOpened = !extraFiltersOpened"
            [attr.aria-expanded]="extraFiltersOpened" aria-controls="order-extra-filters">
            <mat-icon>{{ extraFiltersOpened ? 'expand_less' : 'expand_more' }}</mat-icon>
            Клиент, менеджер и ID
            <span *ngIf="extraFilterCount" class="filterCount">{{ extraFilterCount }}</span>
          </button>
          <div *ngIf="extraFiltersOpened" id="order-extra-filters" class="extraFiltersFields">
            <app-client-selector [control]="clientControl"></app-client-selector>
            <app-user-selector [control]="userControl"></app-user-selector>
            <mat-form-field appearance="outline">
              <mat-label>ID заказа</mat-label>
              <input matInput formControlName="id" type="number" />
            </mat-form-field>
          </div>
        </section>
      </div>
      <div class="searchActions">
        <button [disabled]="loading || searchForm.invalid" type="submit" mat-flat-button class="applyFilterButton"><mat-icon>check</mat-icon> Применить</button>
        <button type="button" mat-stroked-button (click)="resetSearch()" title="Очистить поиск и вернуть фильтры по умолчанию">Сбросить</button>
      </div>
    </form>
  </mat-drawer>

  <div class="listTable">
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    <div #ordersScroll class="tableScroll" (scroll)="onOrdersScroll()" [attr.aria-busy]="loading || loadingMore">
      <table #ordersTable mat-table [dataSource]="dataSource" [trackBy]="trackByOrderId" multiTemplateDataRows>
        <ng-container matColumnDef="ID">
          <th mat-header-cell *matHeaderCellDef>ID</th>
          <td mat-cell *matCellDef="let order" class="id_row" data-order-field="id">
            <span class="mobileFieldLabel">Заказ</span>
            <button type="button" mat-icon-button class="orderExpandButton"
              [attr.aria-label]="(isDetailExpanded(order) ? 'Свернуть заказ ' : 'Раскрыть заказ ') + order.id"
              [attr.aria-expanded]="isDetailExpanded(order)" [attr.aria-controls]="'order-details-' + order.id"
              (click)="$event.stopPropagation(); handleOpenDoc(order)">
              <mat-icon>{{ isDetailExpanded(order) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <span class="orderIdCell" [class.orderIdCell--lookup]="order.lookupMatch === 'id'">
              <span class="orderNumber">
                {{ order.id }}
                <mat-spinner *ngIf="shouldShowDetailLoader(order)" class="orderDetailSpinner"
                  [diameter]="14" aria-label="Загрузка заказа"></mat-spinner>
              </span>
              <span class="orderIdBadges" *ngIf="order.lookupMatch === 'id' || order.source === 'B2C' || order.source === 'PARTS_SELECTION'">
                <span *ngIf="order.lookupMatch === 'id'" class="lookupMatchBadge lookupMatchBadge--id" title="Точный номер">Точный номер</span>
                <span *ngIf="order.source === 'B2C'" class="orderSourceBadge" title="B2C">B2C</span>
                <span *ngIf="order.source === 'PARTS_SELECTION'" class="orderSourceBadge orderSourceBadge--selection" title="ПОДБОР">ПОДБОР</span>
              </span>
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="Дата">
          <th mat-header-cell *matHeaderCellDef>Дата</th>
          <td mat-cell [title]="order.dateLabel" *matCellDef="let order">
            {{ order.dateLabel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Ожидаем">
          <th mat-header-cell *matHeaderCellDef>Ожидаем</th>
          <td mat-cell *matCellDef="let element" data-order-field="expected">
            <span class="mobileFieldLabel">Ожидаем</span>
            <span class="orderDeliveryHint deliveryBadge" [ngClass]="'delivery-' + element.deliveryDeadline.tone"
              [class.delivery-postponed]="element.eta_postponed"
              [matTooltip]="element.deliveryDeadline.title" tabindex="0" [attr.aria-label]="element.deliveryDeadline.title">
              <span class="orderDeliveryDate">{{ element.deliveryDeadline.label }}</span>
              <span class="orderDeliveryStatus">
                <mat-icon>{{ element.deliveryDeadline.icon }}</mat-icon><span class="orderDeliveryStatusText">{{ element.deliveryDeadline.status }}</span>
                <span *ngIf="element.eta_postponed" class="orderDeliveryPostponed">
                  <mat-icon>update</mat-icon>Перенос
                </span>
              </span>
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="Менеджер">
          <th mat-header-cell *matHeaderCellDef>Менеджер</th>
          <td mat-cell *matCellDef="let order">{{ order.manager || '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="Клиент">
          <th mat-header-cell *matHeaderCellDef>Клиент</th>
          <td mat-cell *matCellDef="let order">
            <a *ngIf="order.client_id" [routerLink]="['/client/profile', order.client_id]">{{ order.client }}</a>
            <span *ngIf="!order.client_id">Без клиента</span>
          </td>
        </ng-container>
        <ng-container matColumnDef="clientWithPhone">
          <th mat-header-cell *matHeaderCellDef>Клиент</th>
          <td mat-cell *matCellDef="let order" data-order-field="client">
            <span class="mobileFieldLabel">Клиент</span>
            <div class="clientWithPhone">
              <a *ngIf="order.client_id" [routerLink]="['/client/profile', order.client_id]" [title]="order.client" (click)="$event.stopPropagation()">{{ order.client }}</a>
              <span *ngIf="!order.client_id">Без клиента</span>
              <span class="orderClientPhone">{{ order.client_phone }}</span>
              <span *ngIf="order.lookupMatch === 'phone' || order.lookupMatch === 'phone-fragment'" class="lookupMatchBadge lookupMatchBadge--phone" [title]="order.lookupMatch === 'phone' ? 'Точный телефон' : 'Часть телефона'">
                {{ order.lookupMatch === 'phone' ? 'Точный телефон' : 'Часть телефона' }}
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="Телефон">
          <th mat-header-cell *matHeaderCellDef>Телефон</th>
          <td mat-cell *matCellDef="let order">
            <div class="lookupPhoneCell">
              <span>{{ order.client_phone }}</span>
              <span *ngIf="order.lookupMatch === 'phone' || order.lookupMatch === 'phone-fragment'" class="lookupMatchBadge lookupMatchBadge--phone">
                {{ order.lookupMatch === 'phone' ? 'Точный телефон' : 'Часть телефона' }}
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="Склад">
          <th mat-header-cell *matHeaderCellDef>Склад</th>
          <td mat-cell *matCellDef="let order">{{ order.warehouse }}</td>
        </ng-container>
        <ng-container matColumnDef="Полка сборки">
          <th mat-header-cell *matHeaderCellDef>Полка сборки</th>
          <td mat-cell *matCellDef="let order">
            <div *ngIf="order.staging_cells?.length; else noStagingCell" class="orderStagingCells">
              <span *ngFor="let cell of order.staging_cells" class="orderStagingCell">{{ cell.cell_code }}</span>
            </div>
            <ng-template #noStagingCell><span title="Полка ещё не назначена">—</span></ng-template>
          </td>
        </ng-container>
        <ng-container matColumnDef="Готовность">
          <th mat-header-cell *matHeaderCellDef class="orderReadinessColumn">Готовность</th>
          <td mat-cell *matCellDef="let order" data-order-field="supply">
            <span class="mobileFieldLabel">Готовность</span>
            <span class="status-chip" [ngClass]="order.supplyStatusClass" [title]="order.supplyStatusLabel">
              {{ order.supplyStatusLabel }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="Оплата статус">
          <th mat-header-cell *matHeaderCellDef>Оплата</th>
          <td mat-cell *matCellDef="let order" data-order-field="payment">
            <span class="mobileFieldLabel">Оплата</span>
            <span class="status-chip" [ngClass]="order.paymentStatusClass" [title]="order.paymentStatusLabel">
              {{ order.paymentStatusLabel }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="Отгрузка статус">
          <th mat-header-cell *matHeaderCellDef>Отгрузка</th>
          <td mat-cell *matCellDef="let order" data-order-field="shipment">
            <span class="mobileFieldLabel">Отгрузка</span>
            <span class="status-chip" [ngClass]="order.shipmentStatusClass" [title]="order.shipmentStatusLabel">
              {{ order.shipmentStatusLabel }}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="Оплачено">
          <th mat-header-cell *matHeaderCellDef>Оплачено</th>
          <td mat-cell *matCellDef="let order">
            {{ order.paidTotalLabel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Сумма заказа">
          <th mat-header-cell *matHeaderCellDef>Сумма заказа</th>
          <td mat-cell *matCellDef="let order" data-order-field="sum" [title]="order.sumLabel">
            <span class="mobileFieldLabel">Сумма заказа</span>
            {{ order.sumLabel }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Сумма">
          <th mat-header-cell *matHeaderCellDef>Сумма</th>
          <td mat-cell *matCellDef="let order">
            <div class="sumWithPrepayment">
              <span>{{ order.sumLabel }}</span>
              <span>Счета: {{ order.invoiceTotalLabel }}</span>
              <span *ngIf="order.has_returns">К сбору: {{ order.collectibleTotalLabel }}</span>
              <span *ngIf="order.has_returns">Возвраты: {{ order.returnedTotalLabel }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="К оплате">
          <th mat-header-cell *matHeaderCellDef>К оплате</th>
          <td mat-cell *matCellDef="let order" data-order-field="due">
            <span class="mobileFieldLabel">К оплате</span>
            <div class="sumWithPrepayment">
              <span [title]="order.paymentDueLabel">{{ order.paymentDueLabel }}</span>
              <span *ngIf="order.refund_due_total > 0" [title]="'К возврату: ' + order.refundDueLabel">К возврату: {{ order.refundDueLabel }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="sumWithPrepayment">
          <th mat-header-cell *matHeaderCellDef>Сумма</th>
          <td mat-cell *matCellDef="let order">
            <div class="sumWithPrepayment">
              <span>{{ order.sumLabel }}</span>
              <span>{{ order.paidTotalLabel }}</span>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="columnsToDisplay.length"
            class="{{ element === expandedElement ? 'expandedClass' : 'collapsedClass' }}"
            [attr.inert]="isDetailFrameVisible(element) ? null : ''"
            [attr.aria-hidden]="!isDetailFrameVisible(element)"
          >
            <div class="example-element-detail" [id]="'order-details-' + element.id" [@detailExpand]="isDetailFrameVisible(element) ? 'expanded' : 'collapsed'">
              <div class="detailInner">
                <div class="detailViewport" [attr.aria-busy]="shouldShowDetailLoader(element)">
                  <dl *ngIf="isDetailFrameVisible(element)" class="orderSummary" aria-label="Сведения о заказе">
                    <div><dt>Дата создания</dt><dd>{{ element.dateLabel }}</dd></div>
                    <div><dt>Менеджер</dt><dd>{{ element.manager || '—' }}</dd></div>
                    <div><dt>Склад</dt><dd>{{ element.warehouse || '—' }}</dd></div>
                    <div><dt>Полка сборки</dt><dd>
                      <span *ngIf="!element.staging_cells?.length">Не назначена</span>
                      <span *ngFor="let cell of element.staging_cells" class="orderStagingCell">{{ cell.cell_code }}</span>
                    </dd></div>
                  </dl>
                  <div
                    *ngIf="shouldShowDetailLoader(element) && !isDetailProductsReady(element)"
                    class="orderCompositionLoader"
                    role="status"
                    aria-live="polite"
                  >
                    <mat-spinner [diameter]="26" aria-hidden="true"></mat-spinner>
                    <div class="orderCompositionLoaderText">
                      <strong>Загружаем состав заказа</strong>
                      <span>Товары и данные поставки появятся здесь</span>
                    </div>
                    <div class="orderCompositionLoaderLines" aria-hidden="true">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <div
                    *ngIf="!shouldShowDetailLoader(element) && !isDetailProductsReady(element)"
                    class="orderCompositionEmpty"
                  >
                    В заказе пока нет товаров
                  </div>
                  <div *ngIf="isDetailProductsReady(element)" class="detailBody">
                    <details class="orderActionsDisclosure" [open]="!mobileLayout">
                      <summary><mat-icon aria-hidden="true">touch_app</mat-icon> Действия с заказом<mat-icon class="disclosureChevron" aria-hidden="true">expand_more</mat-icon></summary>
                    <div class="actionGrid actionGridCompact">
                      <section class="actionCard">
                        <div class="actionTitle">Управление</div>
                        <div class="actionButtons">
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Редактировать"
                            (click)="editOrder(element, $event)"
                            [disabled]="isActionLoading(element.id, 'edit')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'edit')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'edit')">edit</mat-icon>
                            Ред.
                          </button>
                          <button *ngIf="hasUnrequestedSupplyForOrder(element.id) && !element.is_canceled"
                            mat-flat-button color="primary" class="procurementAction"
                            matTooltip="Передать закупщику — статус «Нужно заказать»"
                            aria-label="В закупку — передать закупщику со статусом Нужно заказать"
                            (click)="requestProcurementFromList(element, $event)"
                            [disabled]="isActionLoading(element.id, 'request_procurement') || isActionLoading(element.id, 'confirm_procurement')">
                            <mat-icon>add_shopping_cart</mat-icon> В закупку
                          </button>
                          <button
                            *ngIf="hasPlannedSupplyForOrder(element.id) && !element.is_canceled"
                            mat-flat-button
                            color="primary"
                            class="procurementAction"
                            matTooltip="Подтвердить: заказ уже размещён у поставщиков"
                            aria-label="Заказано — подтвердить размещение заказа у поставщиков"
                            (click)="confirmProcurementFromList(element, $event)"
                            [disabled]="isActionLoading(element.id, 'confirm_procurement') || isActionLoading(element.id, 'request_procurement')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'confirm_procurement')"
                              [diameter]="16"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'confirm_procurement')"
                              >done</mat-icon
                            >
                            Заказано
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Все заказы поставщикам по заказу клиента"
                            [routerLink]="['/docs/buy/list']"
                            [queryParams]="{ source_order_id: element.id }"
                            (click)="$event.stopPropagation()"
                          >
                            <mat-icon>shopping_cart</mat-icon>
                            Закупки
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Термопечать заказа"
                            (click)="printOrderThermal(element, $event)"
                            (contextmenu)="openOrderThermalMenu(element, $event)"
                            [disabled]="isThermalPrintLoading(element.id)"
                          >
                            <mat-spinner
                              *ngIf="isThermalPrintLoading(element.id)"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isThermalPrintLoading(element.id)">receipt</mat-icon>
                            Термо
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Взять на обработку"
                            (click)="updateManager(element.id, $event)"
                            [disabled]="isActionLoading(element.id, 'take_manager')"
                            *ngIf="!element.manager"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'take_manager')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'take_manager')"
                              >emoji_people</mat-icon
                            >
                            В работу
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Копировать"
                            (click)="copyOrder(element.id, $event)"
                            [disabled]="isActionLoading(element.id, 'copy')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'copy')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'copy')"
                              >content_copy</mat-icon
                            >
                            Копия
                          </button>
                          <button
                            mat-stroked-button
                            color="warn"
                            title="Отказ от заказа и расчёт возврата"
                            (click)="cancelOrder(element, $event)"
                            [disabled]="isActionLoading(element.id, 'cancel')"

                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'cancel')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'cancel')"
                              >cancel</mat-icon
                            >
                            {{ element.is_canceled ? 'Возврат денег' : 'Отказ и возврат' }}
                          </button>
                          <button
                            mat-stroked-button
                            color="warn"
                            title="Удалить"
                            *ngIf="element.source !== 'B2C'"
                            (click)="deleteDoc(element, $event)"
                            [disabled]="isActionLoading(element.id, 'delete')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'delete')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'delete')"
                              >delete</mat-icon
                            >
                            Удалить
                          </button>
                        </div>
                      </section>

                      <section class="actionCard">
                        <div class="actionTitle">Финансы</div>
                        <div class="actionButtons">
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Создать счет"
                            (click)="createInvoice(element, $event)"
                            [disabled]="isActionLoading(element.id, 'create_invoice')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'create_invoice')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'create_invoice')"
                              >note_add</mat-icon
                            >
                            Счет
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Все счета по заказу"
                            [routerLink]="['/docs/client_invoice/list']"
                            [queryParams]="{ order_id: element.id }"
                            (click)="$event.stopPropagation()"
                          >
                            <mat-icon>receipt_long</mat-icon>
                            Счета
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Провести оплату"
                            (click)="openPaymentDialog(element, $event)"
                            [disabled]="isActionLoading(element.id, 'create_payment')"
                            *ngIf="!element.is_canceled && element.paymentDue > 0"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'create_payment')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'create_payment')"
                              >payments</mat-icon
                            >
                            Оплата
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Провести оплату терминалом"
                            (click)="startTerminalPayment(element, $event)"
                            (contextmenu)="startTerminalPayment(element, $event, true)"
                            [disabled]="isActionLoading(element.id, 'terminal_payment')"
                            *ngIf="!element.is_canceled && element.paymentDue > 0"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'terminal_payment')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'terminal_payment')"
                              >credit_card</mat-icon
                            >
                            Терминал
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="LiqPay"
                            (click)="openPaymentLink(element, $event)"
                            [disabled]="isActionLoading(element.id, 'payment_link')"
                            *ngIf="!element.is_canceled && element.paymentDue > 0"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'payment_link')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'payment_link')"
                              >link</mat-icon
                            >
                            LiqPay
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Оплаты по счету"
                            (click)="openPayments(element, $event)"
                            [disabled]="isActionLoading(element.id, 'open_payments')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'open_payments')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'open_payments')"
                              >account_balance_wallet</mat-icon
                            >
                            Оплаты
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Печать счета по артикулу"
                            (click)="printInvoice(element, 'article', $event)"
                            [disabled]="isActionLoading(element.id, 'print_invoice_article')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'print_invoice_article')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'print_invoice_article')"
                              >receipt_long</mat-icon
                            >
                            Счет арт.
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Печать счета по ID"
                            (click)="printInvoice(element, 'id', $event)"
                            [disabled]="isActionLoading(element.id, 'print_invoice_id')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'print_invoice_id')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'print_invoice_id')"
                              >receipt_long</mat-icon
                            >
                            Счет ID
                          </button>
                        </div>
                      </section>

                      <section class="actionCard">
                        <div class="actionTitle">Отгрузка</div>
                        <div class="actionButtons">
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Создать продажу по заказу"
                            (click)="createSale(element, $event)"
                            [disabled]="isActionLoading(element.id, 'create_sale')"
                            *ngIf="!element.is_canceled"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'create_sale')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'create_sale')"
                              >description</mat-icon
                            >
                            Продажа
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Все отгрузки по заказу"
                            [routerLink]="['/docs/shipment_by_invoice/list']"
                            [queryParams]="{ order_id: element.id }"
                            (click)="$event.stopPropagation()"
                          >
                            <mat-icon>local_shipping</mat-icon>
                            Отгрузки
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Тихая отгрузка готового"
                            (click)="silentShipment(element, $event)"
                            [disabled]="isActionLoading(element.id, 'silent_shipment')"
                            *ngIf="!element.is_canceled"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'silent_shipment')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'silent_shipment')"
                              >done_all</mat-icon
                            >
                            Тихая
                          </button>
                          <button
                            mat-stroked-button
                            color="primary"
                            title="Сборочный лист"
                            (click)="printAssemblySheet(element, $event)"
                            (contextmenu)="openAssemblySheetMenu(element, $event)"
                            [disabled]="isActionLoading(element.id, 'print_assembly_sheet')"
                          >
                            <mat-spinner
                              *ngIf="isActionLoading(element.id, 'print_assembly_sheet')"
                              [diameter]="18"
                            ></mat-spinner>
                            <mat-icon *ngIf="!isActionLoading(element.id, 'print_assembly_sheet')"
                              >fact_check</mat-icon
                            >
                            Сборка
                          </button>
                        </div>
                      </section>
                    </div>

                    </details>

                    <section class="deliveryDetailsCard" *ngIf="hasNovaPoshtaDelivery(element)">
                      <div class="deliveryDetailsHeader">
                        <span class="deliveryDetailsEyebrow">Реквизиты для отправки</span>
                        <strong>Нова пошта</strong>
                      </div>
                      <div class="deliveryDetailsGrid">
                        <div class="deliveryDetailsItem deliveryDetailsPrimary">
                          <span>{{ getNovaPoshtaKindLabel(element) }}</span>
                          <strong>
                            {{
                              getNovaPoshtaWarehouseNumber(element)
                                ? '№ ' + getNovaPoshtaWarehouseNumber(element)
                                : 'номер не указан'
                            }}
                          </strong>
                        </div>
                        <div class="deliveryDetailsItem">
                          <span>Город</span>
                          <strong>{{ getNovaPoshtaCityLine(element) || '—' }}</strong>
                        </div>
                        <div class="deliveryDetailsItem">
                          <span>Получатель</span>
                          <strong>{{ getNovaPoshtaRecipientLine(element) || '—' }}</strong>
                        </div>
                        <div class="deliveryDetailsItem deliveryDetailsWide">
                          <span>Адрес</span>
                          <strong>{{ getNovaPoshtaWarehouseAddress(element) || '—' }}</strong>
                        </div>
                      </div>
                    </section>

                    <div class="orderMeta">
                      <div *ngIf="element.car" class="orderMetaCard orderMetaCar">
                        <mat-icon aria-hidden="true">directions_car</mat-icon>
                        <div class="orderMetaBody">
                          <span class="orderMetaLabel">Автомобиль</span>
                          <span class="orderMetaValue">{{ element.car }}</span>
                        </div>
                      </div>
                      <div *ngIf="element.vin" class="orderMetaCard orderMetaVin">
                        <mat-icon aria-hidden="true">fingerprint</mat-icon>
                        <div class="orderMetaBody">
                          <span class="orderMetaLabel">VIN</span>
                          <span class="orderMetaValue">{{ element.vin }}</span>
                        </div>
                      </div>
                      <ng-container
                        *ngIf="
                          getPartsSelectionLink(element.description) as selectionLink;
                          else orderComment
                        "
                      >
                        <a class="orderMetaCard orderMetaSelection" [routerLink]="['/parts-selection', selectionLink.id]"
                          [attr.aria-label]="selectionLink.label">
                          <mat-icon aria-hidden="true">assignment</mat-icon>
                          <div class="orderMetaBody">
                            <span class="orderMetaLabel">Документ подбора</span>
                            <span class="orderMetaValue">№{{ selectionLink.id }}</span>
                          </div>
                          <mat-icon class="orderMetaLinkIcon" aria-hidden="true">arrow_forward</mat-icon>
                        </a>
                      </ng-container>
                      <ng-template #orderComment>
                        <span *ngIf="getOrderComment(element.description) as comment" class="orderMetaComment"
                          >Комментарий: {{ comment }}</span
                        >
                      </ng-template>
                      <button mat-stroked-button type="button" class="orderMetaNewSelection"
                        matTooltip="Новый подбор с клиентом и автомобилем этого заказа"
                        [disabled]="isActionLoading(element.id, 'create_parts_selection')"
                        [attr.aria-busy]="isActionLoading(element.id, 'create_parts_selection')"
                        (click)="createPartsSelection(element, $event)">
                        <mat-spinner *ngIf="isActionLoading(element.id, 'create_parts_selection'); else newSelectionIcon"
                          [diameter]="18" aria-hidden="true"></mat-spinner>
                        <ng-template #newSelectionIcon><mat-icon aria-hidden="true">post_add</mat-icon></ng-template>
                        {{ isActionLoading(element.id, 'create_parts_selection') ? 'Открываем…' : 'Новый подбор' }}
                      </button>
                      <span class="orderMetaCount">Счетов: <strong>{{ element.invoice_count }}</strong></span>
                      <span *ngIf="element.is_canceled" class="orderMetaCancelled">Отменен</span>
                      <span *ngIf="element.cancel_reason"
                        >Причина: {{ element.cancel_reason }}</span
                      >
                    </div>

                    <div *ngIf="isDetailProductsReady(element)" class="productsTableWrapper" (scroll)="hideImagePreview()">
                      <table
                        mat-table
                        class="productsTable"
                        [class.productsTable--tablet]="displayedColumns.includes('tabletDescription')"
                        [dataSource]="element.products"
                        [trackBy]="trackByProduct"
                      >
                        <ng-container matColumnDef="index">
                          <th mat-header-cell *matHeaderCellDef>No.</th>
                          <td mat-cell *matCellDef="let prod; let i = index" data-product-field="index"><span class="mobileFieldLabel">Позиция</span>{{ i + 1 }}</td>
                        </ng-container>
                        <ng-container matColumnDef="description">
                          <th mat-header-cell *matHeaderCellDef>Наименование</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="description">
                            <div class="orderProductSummary">
                              <ng-container *ngTemplateOutlet="orderProductThumbnail; context: {$implicit: prod}"></ng-container>
                              <div class="productDescriptionCell">
                                <a class="orderProductName" [routerLink]="['/product', prod.productId]" target="_blank" rel="noopener"
                                  (click)="$event.stopPropagation(); hideImagePreview()"
                                  [matTooltip]="prod.description || ''" matTooltipClass="orderProductNameTooltip"
                                  [attr.aria-label]="'Открыть карточку товара: ' + (prod.description || prod.article || prod.productId)">{{ (prod.description || '') | slice:0:32 }}{{ (prod.description?.length || 0) > 32 ? '…' : '' }}</a>
                                <span *ngIf="isClientContext" class="orderProductMeta">{{ prod.brand }} · {{ prod.article }}</span>
                                <div class="productReturnMeta" *ngIf="prod.hasReturns">
                                  <span class="metric-badge metric-danger">
                                    Возврат {{ prod.returnedQuanLabel }}
                                  </span>
                                  <span class="returnDocs" *ngIf="prod.returnDocIdsLabel">
                                    Док.: {{ prod.returnDocIdsLabel }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="article">
                          <th mat-header-cell *matHeaderCellDef>Артикул</th>
                          <td mat-cell *matCellDef="let prod" [title]="prod.article" data-product-field="article"><span class="mobileFieldLabel">Артикул</span>{{ prod.article }}</td>
                        </ng-container>
                        <ng-container matColumnDef="brand">
                          <th mat-header-cell *matHeaderCellDef>Производитель</th>
                          <td mat-cell *matCellDef="let prod" [title]="prod.brand" data-product-field="brand"><span class="mobileFieldLabel">Производитель</span>{{ prod.brand }}</td>
                        </ng-container>
                        <ng-container matColumnDef="provider">
                          <th mat-header-cell *matHeaderCellDef>Источник</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="provider"><span class="mobileFieldLabel">Источник</span>
                            <ng-container *ngTemplateOutlet="productSupply; context: { $implicit: prod, order: element }"></ng-container>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="stock">
                          <th mat-header-cell *matHeaderCellDef>На складе</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="stock"><span class="mobileFieldLabel">На складе</span>{{ prod.stock }}</td>
                        </ng-container>
                        <ng-container matColumnDef="quan">
                          <th mat-header-cell *matHeaderCellDef>Заказано</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="quan"><span class="mobileFieldLabel">Заказано</span>{{ prod.quan }}</td>
                        </ng-container>
                        <ng-container matColumnDef="shipped_quan">
                          <th mat-header-cell *matHeaderCellDef>Отгружено</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="shipped_quan"><span class="mobileFieldLabel">Отгружено</span>
                            <span class="metric-badge" [ngClass]="prod.shippedQuanClass">
                              {{ prod.shipped_quan || 0 }}
                            </span>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="remaining_to_ship_quan">
                          <th mat-header-cell *matHeaderCellDef>К отгрузке</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="remaining_to_ship_quan"><span class="mobileFieldLabel">К отгрузке</span>
                            <span class="metric-badge" [ngClass]="prod.remainingToShipClass">
                              {{ prod.remaining_to_ship_quan || 0 }}
                            </span>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="waiting_supply_quan">
                          <th mat-header-cell *matHeaderCellDef>Дефицит</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="waiting_supply_quan"><span class="mobileFieldLabel">Дефицит</span>
                            <span class="metric-badge" [ngClass]="prod.waitingSupplyClass">
                              {{ prod.waiting_supply_quan || 0 }}
                            </span>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="price">
                          <th mat-header-cell *matHeaderCellDef>Цена</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="price"><span class="mobileFieldLabel">Цена</span>
                            {{ prod.priceLabel }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="sum">
                          <th mat-header-cell *matHeaderCellDef>Сумма</th>
                          <td mat-cell *matCellDef="let prod" data-product-field="sum"><span class="mobileFieldLabel">Сумма</span>
                            {{ prod.sumLabel }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="tabletDescription">
                          <th mat-header-cell *matHeaderCellDef>Информация</th>
                          <td mat-cell *matCellDef="let prod; let i = index">
                            <div class="orderProductSummary">
                              <ng-container *ngTemplateOutlet="orderProductThumbnail; context: {$implicit: prod}"></ng-container>
                              <div class="tabletDescription">
                                <a class="orderProductName" [routerLink]="['/product', prod.productId]" target="_blank" rel="noopener"
                                  (click)="$event.stopPropagation(); hideImagePreview()"
                                  [matTooltip]="prod.description || ''" matTooltipClass="orderProductNameTooltip"
                                  [attr.aria-label]="'Открыть карточку товара: ' + (prod.description || prod.article || prod.productId)">{{ (prod.description || '') | slice:0:32 }}{{ (prod.description?.length || 0) > 32 ? '…' : '' }}</a>
                                <span>{{ prod.brand }}</span>
                                <span>{{ prod.article }}</span>
                                <ng-container *ngTemplateOutlet="productSupply; context: { $implicit: prod, order: element }"></ng-container>
                                <div class="productReturnMeta" *ngIf="prod.hasReturns">
                                  <span class="metric-badge metric-danger">
                                    Возврат {{ prod.returnedQuanLabel }}
                                  </span>
                                  <span class="returnDocs" *ngIf="prod.returnDocIdsLabel">
                                    Док.: {{ prod.returnDocIdsLabel }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                      </table>
                    </div>
                    <dl class="orderTotals" aria-label="Итог заказа">
                      <div><dt>Сумма заказа</dt><dd>{{ element.sumLabel }}</dd></div>
                      <div class="orderTotalsPaid"><dt>Оплачено</dt><dd>{{ element.paidTotalLabel }}</dd></div>
                      <div class="orderTotalsDue"><dt>К оплате</dt><dd>{{ element.paymentDueLabel }}</dd></div>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader orderJournalHeader"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: columnsToDisplay"
          class="example-element-row {{
            element === expandedElement ? 'expandedClass' : 'collapsedClass'
          }}"
          [ngClass]="element.rowClass"
          [class.example-expanded-row]="expandedElement === element"
          [attr.aria-expanded]="isDetailExpanded(element)"
          [attr.aria-busy]="shouldShowDetailLoader(element)"
          [attr.data-keyboard-order-id]="element.id"
          [attr.tabindex]="isClientContext ? null : ((keyboardOrderId || dataSource[0]?.id) === element.id ? 0 : -1)"
          (focus)="keyboardOrderId = element.id"
          (click)="handleOpenDoc(element)"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"
        ></tr>
      </table>
      <div *ngIf="dataSource.length || loadingMore || loadMoreError" class="orderListFooter" aria-live="polite">
        <span>Загружено {{ dataSource.length }} из {{ resultsLength }}</span>
        <span *ngIf="loadingMore" class="orderLoadMoreStatus">
          <mat-spinner [diameter]="18" aria-label="Загрузка заказов"></mat-spinner>
          Загружаем заказы…
        </span>
        <span *ngIf="loadMoreError" class="orderLoadMoreError">Не удалось загрузить следующие заказы.</span>
        <button *ngIf="loadMoreError" type="button" mat-stroked-button (click)="loadMoreOrders()">
          Повторить загрузку
        </button>
      </div>
    </div>
  </div>
</mat-drawer-container>

<ng-template #productSupply let-prod let-order="order">
  <app-order-supply-source
    [orderId]="order.id"
    [product]="prod"
    [supply]="supplyByOrderId[order.id]"
    [cancelled]="!!order.is_canceled"
    [supplyLoading]="!!supplyLoadingByOrderId[order.id]"
    [supplyError]="!!supplyErrorByOrderId[order.id]"
    [refreshVersion]="supplyRefreshVersionByOrderId[order.id] || 0"
  ></app-order-supply-source>
</ng-template>


<ng-template #orderProductThumbnail let-prod>
  <a *ngIf="productImageUrls.get(prod.productId) as url; else noProductPhoto"
    class="orderProductThumbnail" [href]="url" target="_blank" rel="noopener"
    [attr.aria-label]="'Фото: ' + prod.description"
    (mouseenter)="showImagePreview($event, prod)" (mouseleave)="hideImagePreview()"
    (focus)="showImagePreview($event, prod)" (blur)="hideImagePreview()"
    (keydown.escape)="hideImagePreview(); $event.stopPropagation()"
    (click)="$event.stopPropagation(); hideImagePreview()">
    <img [src]="url" [alt]="prod.description" loading="lazy" (error)="handleProductImageError(prod, url)" />
  </a>
  <ng-template #noProductPhoto>
    <span class="orderProductThumbnail noPhoto" role="img" aria-label="Нет фото товара"><mat-icon>image_not_supported</mat-icon></span>
  </ng-template>
</ng-template>
<!-- Outside the animated details and scrolling table so the preview is never clipped. -->
<div *ngIf="hoveredImageUrl" class="orderProductImagePreview" aria-hidden="true"
  [style.left.px]="imagePreviewLeft" [style.top.px]="imagePreviewTop"
  [style.width.px]="imagePreviewSize" [style.height.px]="imagePreviewSize">
  <img [src]="hoveredImageUrl" [alt]="hoveredImageTitle" />
</div>
